import DataGrid from './Datagrid';

export default function ComponentsOverrides(theme) {
  return DataGrid(theme);
}
